module.exports = __webpack_public_path__ + "static/media/preview.54ff9456.png";